import { render } from "./CrmDealKanbanDealDataModalReportModalQuestions.vue?vue&type=template&id=255a60a8"
import script from "./CrmDealKanbanDealDataModalReportModalQuestions.vue?vue&type=script&lang=js"
export * from "./CrmDealKanbanDealDataModalReportModalQuestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__